import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { StationLog } from 'src/app/model/station-logs/station-log';

@Injectable({
  providedIn: 'root',
})
export class StationLogTableService extends BaseTableService<StationLog> {
  private lastScreen: string = '';

  constructor() {
    super();
  }

  setLastScreen(screen: string) {
    this.lastScreen = screen;
  }

  getLastScreen() {
    return this.lastScreen;
  }
}
